import { Link, useNavigate, useLocation } from "react-router-dom";
import { HeartPulse, Search, CalendarClock, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function PatientNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const links = [
    { to: "/buscar", label: "Buscar médicos", icon: Search },
    { to: "/mis-citas", label: "Mis citas", icon: CalendarClock },
    { to: "/mi-perfil", label: "Mi perfil", icon: User },
  ];

  return (
    <header className="sticky top-0 z-20 border-b border-[#E2E8F0] bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
        <Link to="/buscar" className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0284C7] text-white">
            <HeartPulse className="h-4 w-4" strokeWidth={2.6} />
          </div>
          <span className="text-base font-extrabold tracking-tight text-slate-900">SaludCitaRD</span>
        </Link>
        <nav className="flex items-center gap-1">
          {links.map((l) => {
            const active = pathname === l.to;
            return (
              <Link key={l.to} to={l.to}>
                <Button
                  variant="ghost"
                  data-testid={`nav-${l.to.slice(1)}`}
                  className={`rounded-full font-bold ${active ? "bg-sky-50 text-[#0284C7]" : "text-slate-500"}`}
                >
                  <l.icon className="mr-1.5 h-4 w-4" /> {l.label}
                </Button>
              </Link>
            );
          })}
          <div className="mx-2 hidden text-sm font-bold text-slate-700 sm:block">{user?.name}</div>
          <Button
            variant="ghost"
            onClick={async () => { await logout(); navigate("/login"); }}
            className="rounded-full text-slate-400"
            data-testid="logout-btn"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </nav>
      </div>
    </header>
  );
}
